/**
 * Confirmation Modal Types
 * Defines the available modal types with their visual configurations
 */

/**
 * Enum of available confirmation modal types
 */
export enum ConfirmationModalType {
    SUCCESS = 'success',
    WARNING = 'warning',
    DANGER = 'danger',
    INFO = 'info',
    DEFAULT = 'default'
}

/**
 * Configuration interface for each modal type
 * Defines icon colors, text colors, and button colors
 */
export interface ConfirmationModalTypeConfig {
    iconBackgroundColor: string;
    iconColor: string;
    textColor: string;
    buttonColor: 'primary' | 'accent' | 'warn';
    buttonBackgroundColor: string;  // Custom button background color
    buttonTextColor: string;         // Custom button text color
}

/**
 * Type configurations mapping
 * Each type has predefined colors for consistent UX
 */
export const CONFIRMATION_MODAL_TYPE_CONFIGS: Record<ConfirmationModalType, ConfirmationModalTypeConfig> = {
    [ConfirmationModalType.SUCCESS]: {
        iconBackgroundColor: '#10b981',  // Green
        iconColor: '#ffffff',
        textColor: 'text-gray-700',
        buttonColor: 'primary',
        buttonBackgroundColor: '#10b981',  // Green button
        buttonTextColor: '#ffffff'
    },
    [ConfirmationModalType.WARNING]: {
        iconBackgroundColor: '#f97316',  // Orange
        iconColor: '#ffffff',
        textColor: 'text-gray-700',
        buttonColor: 'warn',
        buttonBackgroundColor: '#f97316',  // Orange button
        buttonTextColor: '#ffffff'
    },
    [ConfirmationModalType.DANGER]: {
        iconBackgroundColor: '#ef4444',  // Red
        iconColor: '#ffffff',
        textColor: 'text-gray-700',
        buttonColor: 'warn',
        buttonBackgroundColor: '#ef4444',  // Red button
        buttonTextColor: '#ffffff'
    },
    [ConfirmationModalType.INFO]: {
        iconBackgroundColor: '#3b82f6',  // Blue
        iconColor: '#ffffff',
        textColor: 'text-gray-700',
        buttonColor: 'primary',
        buttonBackgroundColor: '#3b82f6',  // Blue button
        buttonTextColor: '#ffffff'
    },
    [ConfirmationModalType.DEFAULT]: {
        iconBackgroundColor: '#6b7280',  // Gray
        iconColor: '#ffffff',
        textColor: 'text-gray-700',
        buttonColor: 'primary',
        buttonBackgroundColor: '#3b82f6',  // Blue button (Material primary)
        buttonTextColor: '#ffffff'
    }
};

